<style>
#admin{
	/* padding:30px 30px 8px 30px!important; */
	height: calc(100vh - 128px)!important;
}
#admin .q-table__middle{
	overflow-y: hidden !important;
	overflow-x: auto !important;
	height:calc(100% - 48px)!important;
	width: 100%;
}
#admin .q-table{
	overflow: hidden !important;
	height:100% !important;
	width: 100%;
}
#admin tbody{
	display: block;
	max-height: calc(100vh - 300px);
	height:100%;
	width: 100%;
	overflow: auto;
	webkit-overflow-scrolling: touch;
	will-change: scroll-position;
}
#admin .q-table thead{
	height: 48px;
	display: block;
}
#admin .q-table thead tr{
	width: 100%;
	display: table;
}
#admin .q-table tbody tr{
	width: 100%;
	display: table;/*table-row*/
}
#admin .q-table th, #admin .q-table tbody td{
    font-size: 0.95rem;
}
#admin .q-table th, #admin .q-table td {
    padding: 7px 8px;
}
#admin .q-table td {
	word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
}
#admin .q-table__bottom{
	color: #888;
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 0 15px;
}
#admin .q-table__bottom, #admin .q-table__bottom .q-if {
    font-size: 0.88rem;
}
</style>
<template>
  <q-page id="admin" :style="{padding:screenType?'30px 30px 8px 30px!important':'8px'}">
  	<q-card class="fit">
  		<q-card-section style="height: 60px;" >
  			<q-btn @click="btnClick(0,-1)" :label="$t('user.dialog[0]')" icon="fas fa-plus" color="positive" class="q-px-sm" dense>
  				<!--<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{}}</q-tooltip>-->
  			</q-btn>
  			<!--<q-btn @click="btnClick(2,-1)" icon="fas fa-trash-alt" :disable="!selected||selected.length==0" color="red" class="q-ml-md" round dense>
  				<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('admin.dialog[2]')}}</q-tooltip>
  			</q-btn>-->
			<q-input v-model="keyword" @keyup.enter="getData(1)" :placeholder="$t('key')" maxlength="15" style="width:210px;float:right;" rounded outlined dense >
			  <template v-slot:after>
			    <q-btn @click="getData(1)" icon="fa fa-search" color="white" text-color="primary" round dense />
			  </template>
			</q-input>
  		</q-card-section>
  		<q-separator />
  		<q-card-section class="q-pa-none" style="height:calc(100% - 60px);"><!-- :selected.sync="selected" selection="multiple"-->
  			<q-table class="fit" :data="listData" :columns="columns" :loading="loading" :pagination.sync="page" :rows-per-page-options="[15,20,30]" row-key="id" >
  				<tr slot="header" slot-scope="props">
  					<!--<q-th style="width:4%;"><q-checkbox v-if="props.multipleSelect" v-model="props.selected" indeterminate-value="some"/></q-th>-->
          			<q-th key="id" :props="props" style="width:7%;min-width:50px">ID</q-th>
          			<!-- <q-th key="account" :props="props" style="width:23%;">{{$t('admin.name')}}</q-th> -->
          			<q-th key="name" :props="props" style="width:32%;min-width: 200px">{{$t('admin.user')}}</q-th>
					<q-th key="createTime" :props="props" style="width:32%;min-width: 200px">{{$t('createTime')}}</q-th>
					<q-th key="updateTime" :props="props" style="width:18%;min-width: 200px">{{$t('updateTime')}}</q-th>
          			<q-th key="opt" :props="props" style="width:11%;min-width:100px;">{{$t('opt')}}</q-th>
          		</tr>
          		<q-tr slot="body" slot-scope="props" :props="props">
          			<!--<q-td style="width:4%;"><q-checkbox v-model="props.selected"/></q-td>-->
          			<!--<q-td key="id" :props="props" style="width:7%;">{{ (props.row.__index+1)+(curPage-1)*page.rowsPerPage }}</q-td>-->
          			<q-td key="id" :props="props" style="width:7%;min-width:50px">{{ props.row.id }}</q-td>
          			<!-- <q-td key="account" :props="props" style="width:23%;">{{ props.row.account }}</q-td> -->
          			<q-td key="name" :props="props" style="width:32%;min-width:200px;">{{ props.row.name }}</q-td>
					<q-td key="createTime" :props="props" style="width:32%;min-width:200px;">{{ props.row.createTime |parseDateTime}}</q-td>
					<q-td key="updateTime" :props="props" style="width:18%;min-width:200px;">{{ props.row.updateTime |parseDateTime}}</q-td>
          			<q-td key="opt" :props="props" style="width:11%;min-width:100px;">
          				<q-btn @click="btnClick(3,props.rowIndex)" icon="fa fa-search" color="positive" size="sm" flat round dense>
          					<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('detail')}}</q-tooltip>
          				</q-btn>
          				<!-- <q-btn @click="btnClick(2,props.row.__index)" icon="fas fa-times" color="red" class="q-ml-sm" size="sm" flat round dense>
          					<q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">{{$t('delete')}}</q-tooltip>
          				</q-btn> -->
          			</q-td>
          		</q-tr>
          		<div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
          			<q-btn @click="pageClick(0)" :disable="curPage<=1" icon="fas fa-arrow-left" color="primary" size="sm" round dense/>
          			<div class="q-mx-md" style="font-size: small"> {{ curPage }} / {{ totalPage }} </div>
          			<q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary" size="sm" round dense/>
          		</div>
  			</q-table>
  		</q-card-section>
  	</q-card>

  	<q-dialog v-model="dialogStatus" persistent transition-show="scale" transition-hide="scale">
    	<q-card :class="[screenType?'q-pa-lg':'q-pa-sm']" :style="{minWidth:screenType?'450px':'85vw',width:screenType?'':'65vw'}">
        <q-card-section><div class="text-h6">{{$t('user.dialog')[dialogType]}}</div></q-card-section>
        <q-card-section class="fit scroll" style="max-height:60vh;">
          <div v-if="dialogType===0">
          	<q-input ref="account" v-model.trim="form.account" class="q-mt-sm" :label="$t('admin.name')" maxlength="20" counter :placeholder="$t('admin.name')" outlined
          		:rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('admin.msg_name')]" lazy-rules/>
          	<q-input ref="name" v-model.trim="form.name" class="q-mt-sm" :label="$t('admin.user')" maxlength="20" counter :placeholder="$t('admin.user')" outlined
          		:rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=2 || $t('admin.msg_user')]" lazy-rules/>
			<q-input ref="pw" v-model.trim="form.password" type="password" class="q-mt-sm" :label="$t('admin.pw')" maxlength="20" counter :placeholder="$t('admin.pw')" outlined
          		:rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('admin.msg_pw')]" lazy-rules/>
			<q-input ref="pw1" v-model.trim="form.password1" type="password" class="q-mt-sm" :label="$t('admin.pw1')" maxlength="20" counter :placeholder="$t('admin.pw1')" outlined
				:rules="[val => !!val || $t('msg.input_msg'), val => val.length<=20&&val.length>=4 || $t('admin.msg_pw'), val => val===form.password || $t('admin.err2')]" lazy-rules/>
          </div>
		  <div v-if="dialogType===3" style="line-height:38px;font-size:15px;margin:0 auto;">
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('admin.name')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.account}}</div>
		  			</template>
		  		</q-field>
				<q-field borderless>
					<template v-slot:prepend><span style="font-size:15px;">{{$t('admin.user')}}：</span></template>
					<template v-slot:control>
						<div class="self-center full-width no-outline" tabindex="0">{{form.name}}</div>
					</template>
				</q-field>
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('createTime')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.createTime |parseDateTime}}</div>
		  			</template>
		  		</q-field>
		  		<q-field borderless>
		  			<template v-slot:prepend><span style="font-size:15px;">{{$t('updateTime')}}：</span></template>
		  			<template v-slot:control>
		  				<div class="self-center full-width no-outline" tabindex="0">{{form.updateTime |parseDateTime}}</div>
		  			</template>
		  		</q-field>
		  </div>
        </q-card-section>
        <q-card-actions align="right" class="bg-white text-teal">
        	<q-btn :label="$t('close')" :flat="dialogType!==3" color="primary" class="q-mr-md" v-close-popup/>
        	<q-btn v-if="dialogType!==3" @click="confirm()" :label="$t('ok')" :disable="btnDisable" icon="fas fa-check" color="primary"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

  </q-page>
</template>
<script>
import SparkMD5 from 'spark-md5';
export default {
  name: 'admin',
  data () {
    return {
    	keyword:null,
    	selected:[],
    	total:0,
    	curPage:1,
    	page:{ page:1, rowsPerPage:20 },
    	loading:false,
    	columns: [{ name: 'id', field: 'id', align: 'left',sortable: true},
        //{ name: 'account', field: 'account', align: 'left', sortable: true },
        { name: 'name', field: 'name', align: 'left', sortable: true },
		{ name: 'createTime', field: 'createTime', align: 'left', sortable: true },
		{ name: 'updateTime', field: 'updateTime', align: 'left', sortable: true },
        { name: 'opt', field: 'opt', align: 'left'},
    	],
    	listData:[],
    	//dTitle:this.$t('admin.dialog'),
    	dialogStatus:false,
    	dialogType:0,
    	content:{ account:null,password:null,name:null,password1:null },
    	form:{},
		btnDisable:false,
    }
  },
  props:['lang','user'],
  filters: {
    	parseDateTime(time){
    		return time?parseDateTime(time):time;
    	}
    },

  watch:{
  	lang(val, oldVal){
    	this.columns = this.columns;
    },
    pageCount(val, oldVal){//选每页数量 size
    	if(val){
    		this.curPage = 1;
    		this.getData(this.curPage);
    	}
    },
  },
  computed: {
	screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
  	nextPage(){
  		return this.curPage>=Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	totalPage(){
  		return Math.ceil(this.total/this.page.rowsPerPage);
  	},
  	pageCount(){
  		return this.page.rowsPerPage;
  	}
  },
  created(){
  	this.form = JSON.parse(JSON.stringify(this.content));
  	if(localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length>0) {
    	this.getData(1);
  	}else{
  		this.$router.replace('/');//login
  	}
  },
  methods: {
	md5(str) {
		var spark = new SparkMD5();
		spark.append(str);
		var md5Str = spark.end();
		return md5Str;
	},
  	getWH(val){
  		if(val&&val.indexOf('width')!=-1){
  			val = eval('('+val+')');
  			val = val.width+' * '+val.height;
  		}
  		return val;
  	},
  	openDialog(type){
  		this.dialogType = type;
  		this.dialogStatus = true;
  	},
  	getData(index){
    	this.listData = [];
    	this.loading = true;
    	var request = {};
    	//request.ids = [];
		if(this.keyword) request.keyword = this.keyword;
    	request.paging = { index:(index-1)*this.page.rowsPerPage, count:this.page.rowsPerPage, sort:'desc' };
    	this.$ajax(1,'post',true,'/user/list',request).then((res)=>{
    		this.listData = res.data;
    		this.total = res.paging.total;
    		setTimeout(() => { this.loading = false }, 800);
    	}).catch((err)=>{
    		console.log(err)
    		setTimeout(() => { this.loading = false }, 800);
    		this.$emit('islogin',index==1?0:1,err);
    		//if(err.code) this.$notify(2,err.msg,null);
    	})
    },
  	btnClick(type,index){
  		if(type===0){//添加
  			this.form = JSON.parse(JSON.stringify(this.content));
  		}else if(type===3){//查看
			this.form = JSON.parse(JSON.stringify(this.listData[index]));
  		}/*else if(type===2){//删除
  			this.$q.dialog({
    			title: this.$t('msg.prompt'),
    			message: this.$t('admin.msg_del') + this.listData[index].name+' ?',
    			persistent: true,
    			cancel: true,
  			}).onOk((result) => {
    			this.$ajax(1,'delete',true,'/admin/user/delUser/'+this.listData[index].id,null).then((res)=>{
    				this.getData(this.curPage);
    				this.$notify(1,this.$t('admin.ok_del'),null);
    			}).catch((err)=>{
    				console.log(err)
    				this.$emit('islogin',1,err);
    				//if(err.code) this.$notify(2,err.msg,null);
    			})
  			}).onCancel((err) => { })
  		}*/
  		if(type!==2) this.openDialog(type);
  	},
  	confirm(){
  		if(this.dialogType===0){//添加
			this.$refs.account.validate();
			this.$refs.name.validate();
			this.$refs.pw.validate();
			this.$refs.pw1.validate();
  			if (this.$refs.name.hasError || this.$refs.account.hasError || this.$refs.pw.hasError || this.$refs.pw1.hasError) {
  				this.$notify(2,this.$t('msg.input_err'),null);
  				return
  			}else{
				this.btnDisable = true;
  				var request = {};
  				request.account = this.form.account;
  				request.password = this.md5(this.form.password);
				request.name = this.form.name;
    			this.$ajax(1,'put',true,'/user',request).then((res)=>{
    				this.getData(this.curPage);
    				this.dialogStatus = false;
					this.btnDisable = false;
    				this.$notify(1,this.$t('admin.ok_add'),null);
    			}).catch((err)=>{
    				console.log(err)
    				this.$emit('islogin',1,err);
					this.btnDisable = false;
    				//if(err.code) this.$notify(2,err.msg,null);
    			})
  			}
  		}
  	},
  	pageClick(type){//点击页数 type:0-,1+
    	this.curPage= type? this.curPage+1:this.curPage-1;
    	if(this.curPage>0&&this.total!==0&&this.listData.length<this.total){
    		this.getData(this.curPage);
    	}
    },
  }
}
</script>
